import { useEffect, useState } from 'react'

import useTranslation from '@space-core/hooks/useTranslation'

import { MILLISECOND_TO_SECOND } from './constants'
import TimerHelper from './timeHelper'

import * as S from '../accessCall/styles'

export type TimerProps = {
  duration: number
}

const Timer = ({ duration }: TimerProps) => {
  const [time, setTime] = useState(duration)

  const { t } = useTranslation()

  useEffect(() => {
    setTimeout(() => {
      setTime(time - 1)
    }, MILLISECOND_TO_SECOND)
  }, [time])

  if (time <= 0) {
    return (
      <>
        <S.NotifyAnimation className='container _w-auto _mr-2'>
          <div className='circle'></div>
        </S.NotifyAnimation>
        <span className='_text-gray-900 _text-1'>{t('mentorship.session_card.in_progress')}</span>
      </>
    )
  }

  return (
    <span className='_text-gray-900 _text-1'>
      {t('mentorship.session_card.starts_in')}{' '}
      <span id='containerTimer' className='_text-gray-900 _text-1'>
        {TimerHelper.formatTime(time)}
      </span>
    </span>
  )
}

export default Timer
